import styled from '@emotion/styled';

export const CheckboxWrapper = styled.div<{ small?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const CheckboxLabels = styled.label<{ small?: boolean }>`
  margin-bottom: '10px';
  display: grid;
  grid-template-columns: ${props => (props.small ? '28px 1fr' : '32px 1fr')};
  grid-gap: ${props => (props.small ? '8px' : '16px')};
  align-items: center;
  justify-content: flex-start;
`;

export const CheckboxListWrap = styled.ul`
  margin: 0px;
  padding: 0px;
  list-style: none;
`;

export const MultiCheckWrapper = styled.ul`
  margin: 0px;
  padding: 0px;
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 16px;
`;
export const MultiFilterCheckbox = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
`;

export const CheckboxList = styled.li`
  padding: 20px 10px;
  border-bottom: 1px solid #e1e1e1;

  &:last-child {
    border-bottom: 0px solid #e1e1e1;
  }
`;

export const MultiCheckWrap = styled.div<{
  small?: boolean;
}>`
  display: grid;
  grid-template-columns: ${props => (props.small ? '28px 1fr' : '32px 1fr')};
  grid-gap: 16px;
  align-items: center;
  justify-content: flex-start;
`;

export const MultiCheckReverseWrap = styled.div<{
  small?: boolean;
}>`
  display: grid;
  grid-template-columns: ${props => (props.small ? '1fr 28px' : '1fr 32px')};
  grid-gap: 16px;
  align-items: center;
  justify-content: flex-start;
`;

export const CheckIcon = styled.div<{ small?: boolean }>`
  width: ${props => (props.small ? '28px' : '32px')};
  height: ${props => (props.small ? '28px' : '32px')};
  border-radius: ${props => (props.small ? '28px' : '32px')};
  border: 1.5px solid #b5e8ff;
  display: flex;
  align-items: center;
  justify-content: center;
`;
